import axios from 'axios';
import { errorHandlerInterceptor } from './interceptors';

const API_HEADERS = {};
const API_CONFIG = {};

// SET CONFIGURATION
API_HEADERS['X-Requested-With'] = 'XMLHttpRequest';

API_CONFIG.baseURL = process.env.VUE_APP_API_URL;
API_CONFIG.headers = API_HEADERS;
API_CONFIG.timeout = 5000;
API_CONFIG.withCredentials = process.env.NODE_ENV !== 'development';

const API = axios.create(API_CONFIG);

API.interceptors.request.use(config => config, errorHandlerInterceptor);
API.interceptors.response.use(config => config, errorHandlerInterceptor);

// EXPORT CONFIGURATION
export { API };
